import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAward,
  faHandshakeAngle,
  faTrophy,
  faShieldHalved,
} from "@fortawesome/free-solid-svg-icons";

const reasons = [
  {
    icon: faAward,
    title: "ניסיון ומקצועיות",
    description:
      "שנות ניסיון רבות בכל תחומי המשפט – מתיקים פרטניים ועד הליכים מורכבים בשווי מיליוני שקלים. אנו מבטיחים טיפול מעמיק, מקצועי ויסודי בכל מקרה.",
  },
  {
    icon: faHandshakeAngle,
    title: "יחס אישי",
    description:
      "כל לקוח מקבל ליווי אישי, אכפתי וזמין. אנו מקשיבים, מבינים את הצורך האמיתי – ובונים אסטרטגיה משפטית שמותאמת בדיוק עבורכם.",
  },
  {
    icon: faTrophy,
    title: "הצלחה מוכחת",
    description:
      "מאחורינו רזומה עשיר של הצלחות משפטיות מרשימות, שמעידות על היכולת שלנו להשיג את התוצאות הטובות ביותר עבור לקוחותינו.",
  },
  {
    icon: faShieldHalved,
    title: "שקיפות ואמינות",
    description:
      "תמחור הוגן, תקשורת ברורה ועדכונים שוטפים בכל שלב בתיק. בלי הפתעות – רק שירות משפטי שאפשר לסמוך עליו.",
  },
];

const WhyUs = () => {
  return (
    <div className="shane_tm_section" id="why-us">
      <div className="shane_tm_why_us">
        <div className="container">
          <div
            className="why_us_header"
            data-aos="fade-up"
            data-aos-duration="900"
          >
            <span className="why_us_eyebrow">משרד עו״ד וידבסקי ושות׳</span>
            <h2 className="why_us_heading">למה לבחור בנו?</h2>
            <p className="why_us_subheading">
              ארבעה ערכים שמנחים אותנו בכל תיק – ובזכותם הלקוחות שלנו נשארים
              איתנו לאורך זמן וממליצים עלינו הלאה.
            </p>
          </div>

          <div className="why_us_grid">
            {reasons.map((reason, index) => (
              <article
                className="why_us_card"
                key={reason.title}
                data-aos="fade-up"
                data-aos-duration="900"
                data-aos-delay={index * 90}
              >
                <span className="why_us_card_number">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div className="why_us_card_icon">
                  <FontAwesomeIcon icon={reason.icon} />
                </div>
                <h3 className="why_us_card_title">{reason.title}</h3>
                <p className="why_us_card_desc">{reason.description}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyUs;
